import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Subtitle from '../../components/Subtitle';
import ReservationInfo from './ReservationInfo';

const ReservationCanceled = props => (
  <div>
    <Subtitle>
      Appointment Canceled
    </Subtitle>
    <div className="u-mt+">
      <ReservationInfo {...props} />
      <Link
        to={props.scheduleLink}
        className="c-btn c-btn--secondary u-mt+ u-1/1 u-1/2-medium-and-up"
      >
        Schedule another appointment
      </Link>
    </div>
  </div>
);

ReservationCanceled.propTypes = {
  scheduleLink: PropTypes.string,
};
ReservationCanceled.defaultProps = {
  scheduleLink: '/',
};

export default ReservationCanceled;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ReservationCanceled.jsx